import Instructions from "../ai/settings/instructions";
export default function AiSystemPrompt() {
  return (
    <div className="flex-body-wrapper">
      <Instructions />
    </div>
  );
}
